/**
 * HomePageView - Pure UI component for the homepage
 * 
 * This is the View layer that handles only presentation.
 * Contains no logic, hooks, or side effects.
 */
import FeatureCard from './FeatureCard';
import type { FeatureCardData } from './home.schema';
import './HomePageView.css';

interface HomePageViewProps {
  features: FeatureCardData[];
}

function HomePageView({ features }: HomePageViewProps) {
  return (
    <main className="home-page-view-container">
      <h1 className="home-page-view-title">QreditCharge — Credit Orchestration API</h1>
      <p className="home-page-view-subtitle">
        A credit orchestration layer for SaaS products. QreditCharge manages a virtual credit
        currency (qredits) on top of your payment provider — your app only needs to check balances
        and deduct credits.
      </p>
      
      <div className="home-page-view-feature-grid">
        {features.map((feature, index) => (
          <FeatureCard 
            key={index}
            title={feature.title}
            description={feature.description}
            icon={feature.icon}
            color={feature.color}
          />
        ))}
      </div>
    </main>
  );
}

export default HomePageView;